module.exports = __webpack_public_path__ + "img/car.5da88eb6.svg";